import list from './list';
import declare from './declare';
import detail from './detail';
import departmentExamine from './departmentExamine';
import schoolExamine from './schoolExamine'

export default {
    list,
    declare,
    detail,
    departmentExamine,
    schoolExamine
}